import React from 'react';
import styled from 'styled-components';
import { Layout } from 'antd';
import { useCookies } from 'react-cookie';
import { useLocation, useNavigate } from 'react-router-dom';
import { MenuListName, ProjectPageSubMenuList } from 'utils/constant';
import { theme } from 'utils/style/theme';
import nextArrow from 'utils/icon/icon_next-arrow-black.svg';
import MultiLangSelect from './LocalizingSelect';
import UserInfoBox from './UserInfoBox';
import ServerRadio from './ServerRadio';
import MainLogo from 'utils/icon/carpe.svg';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { removeUserInfor, setUserInfor } from 'store/slices/userSlice';
import { cookieServices } from 'services/cookieServices';
import { useTranslation } from 'react-i18next';
import getExpirationDate from 'utils/helper/getExpirationDate';
import SelectStyled from '../../SelectStyled';
import arrowDown from '../../../utils/icon/icon_arrow-down-blue.svg';
import { IAccount, UserRole } from '../../../utils/types/common';
import Cookies from 'js-cookie';
import { getServerUrl, kevinAuthAPI } from '../../../apis/config';

const { Header } = Layout;

/**
 * * 해당 페이지 타이틀, 서버 라디오 버튼, 다국어, 유저 정보
 */

interface IProps {
  collapsed: boolean;
  setCollapsed: (e: any) => void;
  handleCollapse: (e: React.MouseEvent) => void;
}

const HeaderComponent = ({
  collapsed,
  setCollapsed,
  handleCollapse,
}: IProps) => {
  const dispatch = useAppDispatch();
  const dataSource: 'live' | 'dev' = cookieServices.getDataSource() || 'dev';
  const selectedStoryName = useAppSelector(
    (state) => state.breadcumbSlice.storyName,
  );
  const selectedEditName = useAppSelector(
    (state) => state.breadcumbSlice.editName,
  );
  const user = useAppSelector((state) => state.userSlice.userInfor);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies();

  const pathlocation = location.pathname.split('/');
  const mainMenu = `/${pathlocation[1]}`;
  const projectId = `${pathlocation[3]}`;

  const handleDataSourceChange = async (newSource: 'live' | 'dev') => {
    Cookies.set('dataSource', newSource);
    kevinAuthAPI.defaults.baseURL = getServerUrl();
    const response = await kevinAuthAPI.post(`/account/login`, {
      email: user!.email,
      password: 'gagaHold#3',
    }); // TODO: Fix this hardcoded password
    const data = response.data;

    if (data.isSuccess) {
      const userData: IAccount = {
        id: data.account.id,
        accessToken: data.token,
        refreshToken: data.refreshToken,
        user_id: data.account.id,
        master_auth: 1,
        email: data.account.email,
        userName: data.account.userName,
        password: data.account.password,
        organization: data.account.organization,
        role: data.account.role,
        verified: data.account.verified,
        projectAuths: data.account.projectAuths,
      };

      cookieServices.setUserInfo(userData, false);
      cookieServices.setDataSource(newSource, userData);
      dispatch(setUserInfor(userData));
      window.location.replace('/');
    }
  };

  /// 작품언어 드롭다운
  const handleChangeProjectLanguage = (value) => {
    const expirationDate = getExpirationDate(30);
    setCookie('lang', value, {
      path: '/',
      maxAge: expirationDate,
    });
  };

  // 로그아웃
  const handleLogout = () => {
    console.log(`Clicked Logout`);

    const message = window.confirm('로그아웃 하시겠습니까?');

    if (message) {
      dispatch(removeUserInfor());
      cookieServices.removeUserInfo();
    } else {
      return;
    }
  }; // ? END handleLogout

  const menuList = MenuListName();

  const pageSubMenu = ProjectPageSubMenuList();

  const handleClick = () => {
    navigate(mainMenu);
  };
  const handleGoToDetail = () => {
    console.log(`HeaderComponent handleGoToDetail called`);
    navigate(-1);
  };

  return (
    <HeaderBox>
      <LeftBox collapsed={collapsed}>
        {collapsed ? <LogoImg src={MainLogo} alt='logo' /> : <></>}
        {location.pathname === '/' ? (
          <h1 className='text'>{t('constants.menuListName.workManagement')}</h1>
        ) : (
          menuList?.map((v) =>
            !v.subMenus
              ? (location.pathname.indexOf(v.path) !== -1 ||
                  location.pathname === '/') && (
                  <BreadCrumbWrapper key={v.key}>
                    <h1
                      className={`${
                        pathlocation.length > 2 ? 'grayText' : 'text'
                      }`}
                      onClick={handleClick}
                    >
                      {v.name}
                    </h1>
                    {v.key === '/story' ? (
                      <>
                        {selectedStoryName && pathlocation.length > 4 ? (
                          <div className='sub_name'>
                            <img src={nextArrow} alt='arrow' />{' '}
                            <span
                              onClick={handleGoToDetail}
                              style={{ cursor: 'pointer' }}
                            >
                              {selectedStoryName}
                            </span>
                            <img src={nextArrow} alt='arrow' />{' '}
                            <span className='text' onClick={handleGoToDetail}>
                              {selectedEditName}
                            </span>
                          </div>
                        ) : selectedStoryName && pathlocation.length > 2 ? (
                          <div className='sub_name text'>
                            <img src={nextArrow} alt='arrow' />{' '}
                            {selectedStoryName}
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    ) : (
                      <>
                        {pageSubMenu?.map(
                          (v) =>
                            v.key === projectId && (
                              <div className='sub_name text' key={v.key}>
                                <img src={nextArrow} alt='arrow' /> {v.name}
                                {v.type === 'resource' && (
                                  <span style={{ marginLeft: '5px' }}>
                                    (리소스)
                                  </span>
                                )}
                              </div>
                            ),
                        )}
                      </>
                    )}
                  </BreadCrumbWrapper>
                )
              : v.subMenus.map(
                  (item) =>
                    location.pathname.indexOf(item.path) !== -1 && (
                      <h1
                        key={v.key}
                        className={`${
                          pathlocation.length > 2 ? 'grayText' : 'text'
                        }`}
                      >
                        {item.name}
                      </h1>
                    ),
                ),
          )
        )}
      </LeftBox>
      <RightBox>
        {user && user.role === UserRole.SuperAdmin && (
          <SelectStyled
            bordered={false}
            defaultValue={dataSource}
            suffixIcon={<img src={arrowDown} alt='arrow' />}
            style={{ width: 'auto' }}
            onChange={(value, option) =>
              handleDataSourceChange(value as 'live' | 'dev')
            }
            options={[
              {
                value: 'dev',
                label: '개발서버',
              },
              {
                value: 'live',
                label: '라이브서버',
              },
            ]}
          />
        )}

        {(mainMenu === '/user' || mainMenu === '/mail') && <ServerRadio />}

        {(mainMenu === '/story' || mainMenu === '/') && (
          <MultiLangSelect
            onChange={handleChangeProjectLanguage}
            value={cookies.lang ? cookies.lang : 'KO'}
          />
        )}

        <UserInfoBox onClick={handleLogout} />
      </RightBox>
    </HeaderBox>
  );
};

export default HeaderComponent;

const HeaderBox = styled(Header)`
  &.ant-layout-header {
    /* margin-bottom: 16px; */
    position: sticky;
    top: 0;
    background-color: transparent;
    padding-inline: 0;
    height: auto;
    /* line-height: 3.8rem; */
    padding: 0rem 0rem;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LeftBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.collapsed ? '7px' : '0')};

  .trigger {
    margin-right: 2rem;

    svg {
      color: gray;
      width: 1.2rem;
      height: 1.3rem;
    }
  }

  .grayText {
    color: ${theme.colors.dark_200};
    font-weight: ${theme.fontWeights.normal};
    font-size: ${theme.fontSizes.normal};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    line-height: normal;
  }

  .text {
    color: ${theme.colors.dark_500};
    font-weight: ${theme.fontWeights.normal};
    font-size: ${theme.fontSizes.normal};
    display: inline;
    line-height: normal;
  }

  h1 {
    p {
      margin: 0 3px;
      margin-left: 5px;
      width: 6px;
      height: 1.5px;
    }
  }

  .sub_name {
    margin-left: 0.3rem;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;
  }
`;
const RightBox = styled.div`
  display: flex;
  align-items: center;
`;
const LogoImg = styled.img`
  width: 94px !important;
  height: 61px !important;
  cursor: pointer;
  margin-bottom: 12px;
`;

const BreadCrumbWrapper = styled.div`
  display: flex;
`;
